<div class="alert has-body is-shadowless is-radiusless">
    <div class="body">
        <span class="icon-and-text mb-1">
            <span class="icon is-small">
                <i class="tri-alert" aria-hidden="true"></i>
            </span>
            <span class="suptitle">ERROR</span>
        </span>
        <div class="is-multiline buttons">
            @for (modal of errorsModal; track modal) {
                <a (click)="openModal(modal)" class="button is-primary is-small">
                    {{ modal.label }}
                </a>
            }
        </div>
        <div class="divider"></div>
        <span class="icon-and-text mb-1">
            <span class="icon is-small">
                <i class="tri-check-circle" aria-hidden="true"></i>
            </span>
            <span class="suptitle">SUCCESS</span>
        </span>
        <div class="is-multiline buttons">
            @for (modal of successModal; track modal) {
                <a (click)="openModal(modal)" class="button is-primary is-small">
                    {{ modal.label }}
                </a>
            }
        </div>
        <div class="divider"></div>
        <span class="icon-and-text mb-1">
            <span class="icon is-small">
                <i class="tri-exclamation-circle" aria-hidden="true"></i>
            </span>
            <span class="suptitle">INFOS</span>
        </span>
        <div class="is-multiline buttons">
            @for (modal of infosModal; track modal) {
                <a (click)="openModal(modal)" class="button is-primary is-small">
                    {{ modal.label }}
                </a>
            }
        </div>
        <div class="divider"></div>
        <span class="icon-and-text mb-1">
            <span class="icon is-small">
                <i class="tri-question-circle" aria-hidden="true"></i>
            </span>
            <span class="suptitle">OTHER</span>
        </span>
        <div class="is-multiline buttons">
            @for (modal of othersModal; track modal) {
                <a (click)="openModal(modal)" class="button is-primary is-small">
                    {{ modal.label }}
                </a>
            }
        </div>
    </div>
</div>
